import { CalendarClock, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APPOINTMENT_KIND_LABELS } from "@/constant/deals.constant";
import { useGetAppointments } from "@/hooks/useDeals";
import { formatAppointmentWhen } from "@/utils/appointments.utils";

/** The backend returns only appointments this viewer is invited to. */
export default function UpcomingAppointmentsCard({ dealId, testId }: { dealId: string; testId: string }) {
  const { data: appointments = [], isError, refetch } = useGetAppointments(dealId);
  if (!isError && !appointments.length) return null;
  return (
    <section data-testid={testId}>
      <h2 className="mb-2 text-[12px] font-bold uppercase tracking-[1.2px] text-dash-muted">Coming up</h2>
      <div className="rounded-2xl border border-dash-border bg-white p-4">
        {isError ? (
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-sm text-dash-muted">Couldn’t load your showings and meetings.</p>
            <Button type="button" size="sm" variant="dashboardOutline" onClick={() => refetch()}>Try again</Button>
          </div>
        ) : (
          <ul className="flex flex-col gap-4">
            {appointments.map((a) => (
              <li key={a.id} className="flex gap-3">
                <CalendarClock aria-hidden="true" className="mt-0.5 size-4 shrink-0 text-dash-muted" />
                <div className="min-w-0">
                  <p className="break-words text-sm font-medium text-dash-ink">{APPOINTMENT_KIND_LABELS[a.kind]} · {a.title}</p>
                  <p className="text-sm text-dash-muted">{formatAppointmentWhen(a)}</p>
                  {a.location && <p className="mt-0.5 flex items-start gap-1 text-xs text-dash-faint"><MapPin aria-hidden="true" className="mt-0.5 size-3 shrink-0" /><span className="min-w-0 break-words">{a.location}</span></p>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
